import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)
import user from './modules/user'
import publics from './modules/public'
import auction from './modules/auction'
import merchant from './modules/merchant'
import asset from './modules/asset'
import work from './modules/work'
export default new Vuex.Store({
  modules: {
    user: user,
    public: publics,
    auction: auction,
    merchant: merchant,
    asset:asset,
    work:work,
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage
    })
  ]
})
